// 秘钥类型
export const keyType = {
    K_SHCA_ASYMID_RSA: 1,
    K_SHCA_ASYMID_SM2: 2
};

// 秘钥用途
export const keyUsage = {
    K_SHCA_USAGE_ENC: 1, // 加密
    K_SHCA_USAGE_SIGN: 2 // 签署
};

// 签署算法
export const keyEncryption = {
    SHA1withRSA: 3,
    SHA256withRSA: 4,
    SHA384withRSA: 5,
    SHA512withRSA: 6,
    SM2: undefined
};

// SafeEngine参数
export const SafeEngineKeyType = {
    WDC: 10, // 文鼎创
    NULL: 2, // 不做检测
};

export const SESealCtrlKeyType = {
    WDC: 10, // 41文鼎创, jb 文鼎创，传 10 自动识别
    HS: 36, // 华申
    HD: 27 // 华大
};

// SafeEngine设备参数
export const SafeEngineParams = {
    com1: 'com1',
    com2: 'com2'
};
